<template>
   <div class="app-container">
      <el-row :gutter="20">
         <el-col :span="6" :xs="24">
            <el-card class="box-card">
               <template v-slot:header>
                 <div class="clearfix">
                   <span>{{ $t('global.personalInfomation') }}</span>
                 </div>
               </template>
               <div>
                  <div class="text-center">
                     <userAvatar />
                  </div>
                  <ul class="list-group list-group-striped profile-info-list">
                     <li class="list-group-item">
                        <span class="profile-info-label"><svg-icon icon-class="user" />{{ $t('global.userName') }}</span>
                        <div class="profile-info-value">{{ state.user.nickName }}</div>
                     </li>
                     <li class="list-group-item">
                        <span class="profile-info-label"><svg-icon icon-class="phone" />{{ $t('global.userMobile') }}</span>
                        <div class="profile-info-value">{{ state.user.phonenumber }}</div>
                     </li>
                     <li class="list-group-item">
                        <span class="profile-info-label"><svg-icon icon-class="email" />{{ $t('global.userEmail') }}</span>
                        <div class="profile-info-value">{{ state.user.email }}</div>
                     </li>
                     <li class="list-group-item">
                        <span class="profile-info-label"><svg-icon icon-class="tree" />{{ $t('global.departMent') }}</span>
                        <div class="profile-info-value" v-if="state.user.dept">{{ state.user.dept.deptName }} / {{ state.postGroup }}</div>
                     </li>
                     <li class="list-group-item">
                        <span class="profile-info-label"><svg-icon icon-class="peoples" />{{ $t('global.role') }}</span>
                        <div class="profile-info-value">{{ state.roleGroup }}</div>
                     </li>
                     <li class="list-group-item">
                        <span class="profile-info-label"><svg-icon icon-class="date" />{{ $t('global.createDate') }}</span>
                        <div class="profile-info-value">{{ state.user.display_createTime }}</div>
                     </li>
                  </ul>
               </div>
            </el-card>
         </el-col>
         <el-col :span="18" :xs="24" class="profile-right-col">
            <el-card>
               <template v-slot:header>
                 <div class="clearfix">
                   <span>{{ $t('global.basicInformation') }}</span>
                 </div>
               </template>
               <el-tabs v-model="activeTab">
                  <el-tab-pane :label="$t('global.basicInformation')" name="userinfo">
                     <userInfo :user="state.user" />
                  </el-tab-pane>
                  <el-tab-pane :label="$t('global.changePassword')" name="resetPwd">
                     <resetPwd />
                  </el-tab-pane>
               </el-tabs>
            </el-card>
         </el-col>
      </el-row>
   </div>
</template>

<script setup name="Profile">
import userAvatar from "./userAvatar";
import userInfo from "./userInfo";
import resetPwd from "./resetPwd";
import { getUserProfile } from "@/api/system/user";
import dayjs from "dayjs";

const activeTab = ref("userinfo");
const state = reactive({
  user: {},
  roleGroup: {},
  postGroup: {}
});

function getUser() {
  getUserProfile().then(response => {
   //  state.user = response.data;
   state.user = {
      ...response.data,
      display_createTime: dayjs(response.data.createTime).format('YYYY-MM-DD HH:mm:ss')
   }
    state.roleGroup = response.roleGroup;
    state.postGroup = response.postGroup;
  });
};

getUser();
</script>

<style lang="scss" scoped>
/* 左侧个人信息列表：空间够时同一行，不够时换行；文字不随意断行 */
.profile-info-list {
  margin: 0;
  padding: 0;
  list-style: none;
  .list-group-item {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 8px;
    padding: 12px 0;
    min-height: 0;
  }
  .profile-info-label {
    flex-shrink: 0;
    white-space: nowrap;
  }
  .profile-info-value {
    flex: 1 1 auto;
    min-width: min-content;
    text-align: right;
    white-space: normal;
    word-break: normal;
    overflow-wrap: break-word;
    line-height: 1.5;
  }
}

/* 右侧卡片内容区预留右边距，避免基本情报的关闭按钮被父级 overflow 裁切 */
.profile-right-col :deep(.el-card__body) {
  padding-right: 20px;
  box-sizing: border-box;
}
.profile-right-col :deep(.el-tabs__content),
.profile-right-col :deep(.el-tab-pane) {
  overflow: visible;
}

/* 手机端：卡片与 tabs 内容区全宽，便于表单 input 加宽 */
@media (max-width: 768px) {
  .el-col:last-child .el-card__body,
  .el-col:last-child .el-tabs__content {
    width: 100%;
    box-sizing: border-box;
  }
  .el-col:last-child .el-tab-pane {
    width: 100%;
  }
}
</style>
